const DEFAULT_ERROR_MESSAGE = 'Unable to reach the authentication service.';

async function parseResponse(response, fallbackMessage) {
  let payload = null;

  try {
    payload = await response.json();
  } catch (error) {
    payload = null;
  }

  if (!response.ok) {
    throw new Error(payload?.error || fallbackMessage || DEFAULT_ERROR_MESSAGE);
  }

  return payload;
}

export async function getAuthSession() {
  const response = await fetch('/api/auth/session', {
    credentials: 'include',
    headers: {
      Accept: 'application/json'
    }
  });

  if (response.status === 401) {
    return { authenticated: false, user: null };
  }

  return parseResponse(response, DEFAULT_ERROR_MESSAGE);
}

export async function loginWithPassword(credentials) {
  const response = await fetch('/api/auth/login', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify(credentials)
  });

  return parseResponse(response, 'Invalid username or password.');
}

export async function logoutSession() {
  const response = await fetch('/api/auth/logout', {
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'application/json'
    }
  });

  return parseResponse(response, DEFAULT_ERROR_MESSAGE);
}
